addEventListener("DOMContentLoaded", (event) => { 
  var elem = document.querySelector('.grid');
  var msnry = new Masonry( elem, {
    // options
    itemSelector: '.grid-item',
    gutter: 10
  });
   Fancybox.bind('[data-fancybox="gallery"]', {
    // Your custom options for a specific gallery
  }); 
});